import React, { useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import RedeemIcon from "@mui/icons-material/Redeem";
import CalculateIcon from "@mui/icons-material/Calculate";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DiamondIcon from "@mui/icons-material/Diamond";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GiftImage from "../../Gift of Gold and Elegance.png";
import {
  getActiveConfigurationsRequest,
  getActiveOffersRequest,
  getAppConfigRequest,
  getBullionRatesRequest,
  getCarouselRequest,
  getDiamondPointsRequest,
  getHoldingsRequest,
  getSipBalanceRequest,
  getStoreListForUserRequest,
} from "../../redux/Dashboard/dashboardSlice";
import {
  getCustomerRequest,
  getVipActiveConfigurationsRequest,
} from "../../redux/Profile/profileSlice";
import CarouselSlider from "../CarouselSection/CarouselSlider";
import TodayIcon from "@mui/icons-material/Today";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SipIcon from "@mui/icons-material/Sip";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CustomerInteraction from "../CustomerInteraction/CustomerInteraction";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getNotificationRequest } from "../../redux/Notification/notificationSlice";
import DashboardNotificationDialog from "./DashboardNotificationDialog";
import { useAppTheme } from "../../theme/useAppTheme";
import useCurrency from "../../hooks/useCurrency";

const formatPointDuration = (time, unit) => {
  const count = Number(time) || 0;
  const base = String(unit || "day").toLowerCase();
  const word =
    count === 1
      ? base.replace(/s$/, "")
      : base.endsWith("s")
        ? base
        : `${base}s`;
  return `${count} ${word}`;
};

const diamondEarnSections = (activeConfigurations, customerType) => {
  const schemes = Array.isArray(activeConfigurations?.value)
    ? activeConfigurations.value
    : [];

  return schemes
    .filter((scheme) => scheme?.enabled === true)
    .map((scheme) => {
      const config = scheme.config;
      let lines = [];

      if (Array.isArray(config)) {
        lines = config
          .filter((item) => item?.enabled === true)
          .filter((item) => {
            if (!item?.custType) return true;
            return (
              String(item.custType).toLowerCase() ===
              String(customerType || "standard").toLowerCase()
            );
          })
          .map((item) => {
            const firstCount = item.initialTransactions;
            const transactionWord =
              Number(firstCount) === 1 ? "transaction" : "transactions";
            return `Buy ${item.metalName} to earn ${item.initialTransactionPoints} Diamond Points on your first ${firstCount} ${transactionWord}, then ${item.afterInitalTransactionsPoints} Points per transaction. Points are valid for ${formatPointDuration(item.expireTime, item.expireTimeUnit)}.`;
          });
      } else if (config && typeof config === "object") {
        lines = [
          `Earn ${config.points} Diamond Points. Points are valid for ${formatPointDuration(config.expireTime, config.expireTimeUnit)}.`,
        ];
      }

      return {
        title: scheme.displayName || scheme.schemeName,
        lines,
      };
    })
    .filter((section) => section.lines.length > 0);
};

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    data,
    bullionRates,
    appConfig,
    carousel,
    diamondPoints,
    activeConfigurations,
    activeOffers,
  } = useSelector((state) => state.dashboard || {});
  console.log("activeOffers", activeOffers);

  const { customer: fetchedCustomer } = useSelector(
    (state) => state.profile || {},
  );

  const customerType = fetchedCustomer?.customer_type;
  const isVipCustomer = customerType === "vip";

  const [selectedMetal, setSelectedMetal] = React.useState(null);
  const [showOfferDialog, setShowOfferDialog] = React.useState(false);
  const [showEarnDialog, setShowEarnDialog] = React.useState(false);

  const [topCarousel, setTopCarousel] = React.useState(null);
  const [midCarousel, setMidCarousel] = React.useState(null);
  const [bottomCarousel, setBottomCarousel] = React.useState(null);

  const decimal = appConfig?.decimalPrecision ?? 4;
  const buyFieldInputControl = appConfig?.buyFieldInputControl ?? {};
  const featureToggle = appConfig?.featureToggle ?? {};
  const taxtype = appConfig?.taxtype ?? "GST";

  const buyText = appConfig?.buyTextLabel;
  const { data: notifications } = useSelector(
    (state) => state.notification || {},
  );

  const [openNotificationDialog, setOpenNotificationDialog] =
    React.useState(false);

  const [latestNotification, setLatestNotification] = React.useState(null);
  useEffect(() => {
    if (notifications && notifications.length > 0) {
      const latest = notifications[0];

      const lastShownId = localStorage.getItem("lastDashboardNotification");

      if (latest._id !== lastShownId) {
        setLatestNotification(latest);
        setOpenNotificationDialog(true);
        localStorage.setItem("lastDashboardNotification", latest._id);
      }
    }
  }, [notifications]);
  const { vipActiveConfigurations } = useSelector((state) => state.profile);
  useEffect(() => {
    const hasSeenOffer = localStorage.getItem("hasSeenOffer");
    if (activeOffers?.bannerLink && !hasSeenOffer) {
      setShowOfferDialog(true);
      localStorage.setItem("hasSeenOffer", "true");
    }
  }, [activeOffers]);
  console.log("vipActiveConfigurations", vipActiveConfigurations);
  const themeColors = useAppTheme();

  const { symbol, format } = useCurrency();

  useEffect(() => {
    dispatch(
      getHoldingsRequest({ jeweller: `${process.env.REACT_APP_JEWELLER_ID}` }),
    );
    dispatch(
      getBullionRatesRequest({ id: `${process.env.REACT_APP_JEWELLER_ID}` }),
    );
    dispatch(getAppConfigRequest());
    dispatch(getCarouselRequest());
    dispatch(getSipBalanceRequest());
    dispatch(
      getStoreListForUserRequest({
        id: `${process.env.REACT_APP_JEWELLER_ID}`,
      }),
    );
    dispatch(getDiamondPointsRequest());
    dispatch(getActiveConfigurationsRequest());
    if (fetchedCustomer?.phone) {
      dispatch(
        getCustomerRequest({
          phone: fetchedCustomer.phone,
          jeweller: process.env.REACT_APP_JEWELLER_ID,
          deviceDetails: navigator.userAgent,
        }),
      );
    }
    dispatch(getVipActiveConfigurationsRequest());
    dispatch(getNotificationRequest());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getActiveOffersRequest());
  }, []);
  useEffect(() => {
    if (bullionRates && bullionRates.length > 0 && !selectedMetal) {
      const firstBuyMetal = bullionRates.find(
        (item) => item.rateType === "Buy",
      );
      if (firstBuyMetal) {
        setSelectedMetal({
          metalName: firstBuyMetal.bullion?.metalName || "Unknown",
          purity: firstBuyMetal.bullion?.purity || "",
          karat: firstBuyMetal.bullion?.karat || "",
          buyRate: firstBuyMetal.ratePerGram || 0,
          cgst: Number(firstBuyMetal.bullion?.cgst) || 0,
          sgst: Number(firstBuyMetal.bullion?.sgst) || 0,
          tax: Number(firstBuyMetal.bullion?.tax) || 0,
          cess: Number(firstBuyMetal.bullion?.cess) || 0,
        });
      }
    }
  }, [bullionRates, selectedMetal]);

  useEffect(() => {
    if (selectedMetal && amount) {
      const g = parseFloat(amount) / selectedMetal.buyRate;
      setGrams(g.toFixed(decimal));
    } else {
      setGrams("");
      setAmount("");
    }
  }, [selectedMetal]);

  //carousel handling
  const normalizeSlides = (slides) =>
    (slides || []).filter((s) => s.enabled && s.foreground);

  useEffect(() => {
    if (!carousel || !Array.isArray(carousel)) return;

    const locations = ["home_top", "home_middle", "home_bottom"];
    const carousels = {};

    locations.forEach((loc) => {
      const carouselSlot = carousel.find(
        (c) => c.location === loc && c.enabled,
      );

      if (carouselSlot) {
        const enabledSlides = normalizeSlides(carouselSlot.slides);
        console.log("carouselSlot", carouselSlot);

        if (enabledSlides.length > 0) {
          const normalizedSlides = enabledSlides.map((s) => {
            const images = (s.foreground.images || []).map((img) =>
              img.startsWith("http")
                ? img
                : `${process.env.REACT_APP_CDN_URL}/${process.env.REACT_APP_PACKAGE_NAME}/${img}`,
            );

            const media = (s.foreground.media || []).map((m) => ({
              ...m,
              path: m.path.startsWith("http")
                ? m.path
                : `${process.env.REACT_APP_CDN_URL}/${process.env.REACT_APP_PACKAGE_NAME}/${m.path}`,
            }));

            return {
              ...s,
              foreground: {
                ...s.foreground,
                images,
                media,
              },
            };
          });

          carousels[loc] = {
            slides: normalizedSlides,
            height: Number(carouselSlot.height) || 200,
            showNavigator: Boolean(carouselSlot.shownavigator),
            duration: Number(carouselSlot.duration) || 4,
          };
        }
      }
    });

    setTopCarousel(carousels.home_top || null);
    setMidCarousel(carousels.home_middle || null);
    setBottomCarousel(carousels.home_bottom || null);
  }, [carousel]);

  const { data: holdings } = useSelector((state) => state.dashboard || {});

  const totalBalances = React.useMemo(() => {
    let totalMetalBalance = 0;
    let totalMoneyBalance = 0;

    if (holdings && Array.isArray(holdings)) {
      holdings.forEach((holding) => {
        const metalName = holding.metalName;
        const availableBalance =
          (Number(holding.availableBalance) || 0) +
          (Number(holding.metalsipbalance) || 0);
        const buyRate = Number(holding.buyRate) || 0;
        const moneyBalance = Number(holding.moneysipbalance) || 0;

        if (metalName === "Money") {
          totalMoneyBalance += moneyBalance;
        } else {
          totalMetalBalance += availableBalance * buyRate;
        }
      });
    }

    return {
      totalMetalBalance,
      totalMoneyBalance,
    };
  }, [holdings]);

  const [grams, setGrams] = React.useState("");
  const [amount, setAmount] = React.useState("");

  const handleGramsChange = (e) => {
    const val = e.target.value;
    const regex = new RegExp(`^\\d*(\\.\\d{0,${decimal}})?$`);

    if (val === "" || regex.test(val)) {
      setGrams(val);
      if (selectedMetal && val && !isNaN(val)) {
        const amt = parseFloat(val) * selectedMetal.buyRate;
        setAmount(amt.toFixed(decimal));
      } else {
        setAmount("");
      }
    }
  };

  const handleAmountChange = (e) => {
    const val = e.target.value;
    const regex = new RegExp(`^\\d*(\\.\\d{0,${decimal}})?$`);

    if (val === "" || regex.test(val)) {
      setAmount(val);

      if (selectedMetal && val && !isNaN(val)) {
        const g = parseFloat(val) / selectedMetal.buyRate;
        setGrams(g.toFixed(decimal));
      } else {
        setGrams("");
      }
    }
  };

  const handleQuickAmountSelect = (amt) => {
    setAmount(amt);
    if (selectedMetal && !isNaN(amt)) {
      const g = parseFloat(amt) / selectedMetal.buyRate;
      setGrams(g.toFixed(decimal));
    } else {
      setGrams("");
    }
  };

  const getEffectiveTaxPercent = (metal) => {
    if (!metal) return 0;

    if (taxtype === "GST") {
      const gst = (Number(metal.cgst) || 0) + (Number(metal.sgst) || 0);
      return gst;
    }

    if (taxtype === "VAT") {
      const vat = Number(metal.tax) || 0;
      const cess = Number(metal.cess) || 0;

      // const cessOnVat = vat * (cess / 100);
      return vat;
    }

    return 0;
  };

  const metalCards = React.useMemo(() => {
    const cards = Object.values(
      (bullionRates || []).reduce((acc, item) => {
        const metalName = item.bullion?.metalName || "Unknown";
        const purity = item.bullion?.purity || "";
        const karat = item.bullion?.karat || "";
        const key = `${metalName}-${karat}-${purity}`;

        if (!acc[key]) {
          acc[key] = { Buy: null, Sell: null, metalName, purity, karat };
        }
        acc[key][item.rateType] = item;
        return acc;
      }, {}),
    );

    (holdings || []).forEach((holding) => {
      const metalName = holding.metalName || holding.bullion?.metalName;
      if (!metalName || metalName === "Money") return;

      const purity = holding.purity ?? holding.bullion?.purity ?? "";
      const alreadyShown = cards.some(
        (card) =>
          String(card.metalName).toLowerCase() === metalName.toLowerCase() &&
          Number(card.purity) === Number(purity),
      );
      if (alreadyShown) return;

      const karat = String(
        holding.karat || holding.bullion?.karat || "",
      ).replace(/[^0-9]/g, "");
      cards.push({
        Buy: { ratePerGram: Number(holding.buyRate) || 0 },
        Sell: { ratePerGram: Number(holding.sellRate) || 0 },
        metalName,
        purity,
        karat,
      });
    });

    return cards;
  }, [bullionRates, holdings]);

  return (
    <Box
      sx={{
        background: themeColors.scaffoldGradientColors,
        pb: 0,
        width: "100%",
        maxWidth: 1350,
        mx: "auto",
        borderRadius: { xs: 0, md: "30px" },
        overflowX: "hidden",
      }}
    >
      <Box sx={{ height: "100%", overflowY: "auto", px: 0, py: 2 }}>
        {(featureToggle.vipCustomer || featureToggle.vip_customer) && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 1,
              mb: 2,
            }}
          >
            <Box
              onClick={() => navigate("/vipMembership")}
              sx={{
                cursor: "pointer",
                width: "90%",
                maxWidth: 420,
                height: 40,
                borderRadius: "25px",
                background: "transparent",
                position: "relative",
                overflow: "hidden",
                border: "1px solid grey",
              }}
            >
              <Box
                sx={{
                  width: `${isVipCustomer ? 100 : 60}%`,
                  height: "100%",
                  background: "#FBC02D",
                  borderRadius: "25px",
                }}
              />

              <Typography
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: themeColors.text,
                  gap: 0.5,
                }}
              >
                {isVipCustomer
                  ? "Your VIP Journey"
                  : "Complete the task to be a "}
                {!isVipCustomer && (
                  <Box
                    component="span"
                    sx={{ color: "#FBC02D", fontWeight: 800 }}
                  >
                    VIP
                  </Box>
                )}
              </Typography>

              <Box
                sx={{
                  position: "absolute",
                  left: 4,
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  background: "#E91E63",
                }}
              />
            </Box>
          </Box>
        )}
        {topCarousel ? (
          <CarouselSlider
            slides={topCarousel.slides}
            height={topCarousel.height}
            showNavigator={topCarousel.showNavigator}
            duration={topCarousel.duration}
          />
        ) : (
          <Box
          // sx={{
          //   height: 200,
          //   display: "flex",
          //   justifyContent: "center",
          //   alignItems: "center",
          //   background: themeColors.scaffoldGradientColors,
          //   borderRadius: 2,
          // }}
          >
            {/* <img
              src="/images/gold_price_table.png"
              alt="default-carousel"
              style={{ height: "100%", objectFit: "cover" }}
            /> */}
          </Box>
        )}

        <Grid container spacing={2} sx={{ mt: 3, px: { xs: 1.5, sm: 2 } }}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Card
              sx={{
                background: themeColors.mediumContainer,
                border: `1px solid ${themeColors.border}`,
                borderRadius: "20px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                color: themeColors.text,
                width: "100%",
                transition: "transform 0.3s",
                "&:hover": { transform: "translateY(-5px)" },
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: themeColors.text, fontSize: "16px" }}
                >
                  Value of Holdings
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    mt: 1,
                    fontSize: { xs: "1.4rem", sm: "2.125rem" },
                    wordBreak: "break-word",
                  }}
                >
                  {symbol}
                  {totalBalances.totalMetalBalance.toFixed(decimal)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }} sx={{ mb: 2 }}>
            <Card
              sx={{
                background: themeColors.mediumContainer,
                border: `1px solid ${themeColors.border}`,
                borderRadius: "20px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                color: themeColors.text,
                width: "100%",
                transition: "transform 0.3s",
                "&:hover": { transform: "translateY(-5px)" },
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: themeColors.text, fontSize: "16px" }}
                >
                  Cash Balance
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    mt: 1,
                    fontSize: { xs: "1.4rem", sm: "2.125rem" },
                    wordBreak: "break-word",
                  }}
                >
                  {symbol}
                  {totalBalances.totalMoneyBalance.toFixed(decimal)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {midCarousel && (
          <CarouselSlider
            slides={midCarousel.slides}
            height={midCarousel.height}
            showNavigator={midCarousel.showNavigator}
            duration={midCarousel.duration}
          />
        )}

        <Box
          sx={{
            mt: 3,
            px: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          {metalCards.length > 0 &&
            metalCards.map((metal, index) => {
              const metalName =
                metal.metalName ||
                metal.Buy?.bullion?.metalName ||
                metal.Sell?.bullion?.metalName;
              const buyRate = metal.Buy?.ratePerGram || 0;
              const metalKey = metalName?.toLowerCase();
              const purity = metal.purity || "";
              const karat = metal.karat || "";

              const matchHolding =
                holdings?.find(
                  (h) =>
                    h.bullion?.metalName === metalName &&
                    Number(h.bullion?.purity) === Number(purity),
                ) || null;

              let holdingWeight = 0.0;
              let holdingAmount = 0.0;
              if (matchHolding) {
                const availableBalance =
                  Number(matchHolding.availableBalance) || 0;
                const metalsipbalance =
                  Number(matchHolding.metalsipbalance) || 0;
                const holdingBuyRate = Number(matchHolding.buyRate) || 0;

                holdingWeight = availableBalance + metalsipbalance;
                holdingAmount = holdingWeight * holdingBuyRate;
              }

              return (
                <Card
                  key={index}
                  sx={{
                    width: { xs: "100%", sm: "calc(50% - 16px)", md: 320 },
                    maxWidth: "100%",
                    borderRadius: "22px",
                    overflow: "hidden",
                    background: themeColors.mediumContainer,
                    border: `1px solid ${themeColors.border}`,
                    color: themeColors.text,
                    boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
                  }}
                >
                  {/* TOP METAL LABEL */}
                  <Box
                    sx={{
                      mx: 2,
                      mt: 2,
                      mb: 1,
                      px: 2,
                      py: 1,
                      borderRadius: "18px",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "16px",
                      background:
                        metalKey === "gold"
                          ? "linear-gradient(135deg, #FFD700, #DAA520)"
                          : metalKey === "platinum"
                            ? "linear-gradient(135deg, #E5E4E2, #8E9EAB)"
                            : "linear-gradient(135deg, #E0E0E0, #BDBDBD)",
                      color: "#000",
                    }}
                  >
                    {metalName} {karat}K - {purity}
                  </Box>

                  {/* BODY */}
                  <Box sx={{ px: 3, pb: 3 }}>
                    <Typography sx={{ fontSize: "14px", opacity: 0.9 }}>
                      Buy Rate: {symbol} {buyRate.toFixed(decimal)}/gm
                    </Typography>

                    <Typography sx={{ mt: 1, fontSize: "15px" }}>
                      Holding Amount:{" "}
                      <b>
                        {symbol} {holdingAmount.toFixed(decimal)}
                      </b>
                    </Typography>

                    <Typography sx={{ mt: 0.5, fontSize: "14px" }}>
                      Weight: <b>{holdingWeight.toFixed(decimal)} g</b>
                    </Typography>
                  </Box>
                </Card>
              );
            })}
        </Box>

        {featureToggle.buy && (
          <Box
            sx={{
              background: themeColors.bigContainer,
              border: `1px solid ${themeColors.border}`,
              borderRadius: "30px",
              boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
              p: { xs: 2, sm: 3 },
              mx: { xs: 1.5, sm: 2 },
              mt: 3,
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: themeColors.text,
                textAlign: "center",
              }}
            >
              Select Metal
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {bullionRates
                ?.filter((item) => item.rateType === "Buy")
                ?.map((item, index) => {
                  const metalName = item.bullion?.metalName || "Unknown";
                  const purity = item.bullion?.purity || "";
                  const karat = item.bullion?.karat || "";
                  const buyRate = item.ratePerGram || 0;
                  const cgst = item.bullion?.cgst || "";
                  const sgst = item.bullion?.sgst || "";
                  const tax = item.bullion?.tax || "";
                  const cess = item.bullion?.cess || "";
                  const isSelected =
                    selectedMetal &&
                    selectedMetal.metalName === metalName &&
                    selectedMetal.purity === purity;

                  return (
                    <Card
                      key={index}
                      onClick={() =>
                        setSelectedMetal({
                          metalName,
                          purity,
                          karat,
                          buyRate,
                          cgst,
                          sgst,
                          tax,
                          cess,
                        })
                      }
                      sx={{
                        width: "auto",
                        maxWidth: "100%",
                        minHeight: 45,
                        px: 1.5,
                        py: 0.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        borderRadius: "25px",
                        cursor: "pointer",
                        background: isSelected
                          ? themeColors.primary
                          : "transparent",
                        border: isSelected
                          ? "none"
                          : `1px solid ${themeColors.scaffold}`,
                        boxShadow: isSelected
                          ? "0 0 15px rgba(111,175,142,0.6)"
                          : "none",
                        transition: "all 0.25s ease",
                        border: `1px solid ${themeColors.scaffold}`,
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "bold", color: themeColors.text }}
                      >
                        {metalName}-
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "bold", color: themeColors.text }}
                      >{`${karat}k-${purity}`}</Typography>
                    </Card>
                  );
                })}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                label="Enter Grams"
                value={grams}
                onChange={handleGramsChange}
                disabled={!buyFieldInputControl?.grams}
                sx={{
                  input: { color: themeColors.text },

                  "& .MuiOutlinedInput-root": {
                    borderRadius: "25px",
                    backgroundColor: themeColors.primary,

                    "& fieldset": {
                      border: `1px solid ${themeColors.scaffold}`,
                    },
                    "&:hover fieldset": {
                      borderColor: "#999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: themeColors.scaffold,
                    },
                  },

                  "& .MuiInputLabel-root": {
                    color: themeColors.text,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: themeColors.text,
                  },
                }}
              />
              <SwapHorizIcon
                sx={{
                  fontSize: 26,
                  background: themeColors.smallContainer,
                  color: themeColors.text,
                  borderRadius: "50%",
                  p: 1,
                  border: `1px solid ${themeColors.border}`,
                }}
              />
              <TextField
                fullWidth
                variant="outlined"
                label="Enter Amount"
                value={amount}
                onChange={handleAmountChange}
                disabled={!buyFieldInputControl?.amount}
                sx={{
                  input: { color: themeColors.text }, // text

                  "& .MuiOutlinedInput-root": {
                    borderRadius: "20px",
                    backgroundColor: themeColors.primary,

                    "& fieldset": {
                      border: `1px solid ${themeColors.scaffold}`,
                    },
                    "&:hover fieldset": {
                      borderColor: "#999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: themeColors.scaffold,
                    },
                  },

                  "& .MuiInputLabel-root": {
                    color: themeColors.text,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: themeColors.text,
                  },
                }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {[101, 501, 1001, 5001].map((amt) => (
                <Button
                  key={amt}
                  variant="contained"
                  onClick={() => handleQuickAmountSelect(amt)}
                  sx={{
                    borderRadius: "25px",
                    background: themeColors.bigContainer,
                    color: themeColors.text,
                    border: `1px solid ${themeColors.scaffold}`,
                    width: { xs: "calc(50% - 16px)", sm: "200px" },
                    maxWidth: "100%",
                    textTransform: "none",
                    px: 4,
                    py: 1,
                    mb: 1,
                    "&:hover": {
                      background: themeColors.primary,
                    },
                  }}
                >
                  {symbol}
                  {amt}
                </Button>
              ))}
            </Box>

            {/* <Typography
            align="center"
            sx={{ fontSize: "18px", color: themeColors.text }}
          >
            Current Price (exclusive of{" "}
            {getEffectiveTaxPercent(selectedMetal).toFixed(decimal)}%{" "}
            {taxtype === "GST" ? "GST" : "TAX"}):
          </Typography> */}
            <Typography
              align="center"
              sx={{
                fontWeight: "bold",
                fontSize: "20px",
                color: themeColors.text,
              }}
            >
              Buy Rate:{" "}
              {selectedMetal
                ? `${symbol}${selectedMetal.buyRate.toFixed(decimal)}/g`
                : "Select a metal to view rate"}
            </Typography>

            {featureToggle.buy && (
              <Button
                variant="contained"
                onClick={() =>
                  navigate("/OrderSummary", {
                    state: { metal: selectedMetal, grams, amount, appConfig },
                  })
                }
                disabled={!selectedMetal || !grams || !amount}
                sx={{
                  background: themeColors.primary,
                  border: `1px solid ${themeColors.scaffold}`,
                  color: themeColors.text,
                  borderRadius: "30px",
                  width: "100%",
                  py: 1.6,
                  fontSize: "18px",
                  fontWeight: "bold",
                  fontSize: "20px",
                  "&:hover": {
                    background: themeColors.primary,
                  },
                }}
              >
                {buyText}
              </Button>
            )}
          </Box>
        )}

        {(featureToggle.diamondPoints || featureToggle.diamond_points) && (
          <Card
            sx={{
              mx: 2,
              mt: 5,
              background: themeColors.mediumContainer,
              border: `1px solid ${themeColors.border}`,
              borderRadius: "20px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
              color: themeColors.text,
            }}
          >
            <CardContent sx={{ textAlign: "center", p: 3 }}>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", fontSize: "25px" }}
              >
                💎 Diamond Points:{diamondPoints?.totalAvailable ?? 0}
              </Typography>
              <Typography
                variant="body2"
                onClick={() => setShowEarnDialog(true)}
                sx={{
                  mt: 1,
                  ml: 10,
                  color: themeColors.text,
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontSize: "18px",
                }}
              >
                How to Earn Diamond Points
              </Typography>
              {/* <Typography variant="body2" sx={{ color: themeColors.text }}>
                Points Validity: {diamondPoints?.validity ?? 0}{" "}
                {diamondPoints?.validityUnit ?? ""}
              </Typography> */}
            </CardContent>
          </Card>
        )}

        <Box sx={{ mt: 5, px: 3, textAlign: "center" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: "25px",
              color: themeColors.primary,
            }}
          >
            Services
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 4,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: 3,
              }}
            >
              {[
                {
                  key: "redeem",
                  icon: <RedeemIcon sx={{ fontSize: 35, color: "#6c63ff" }} />,
                  label: "Redeem",
                  path: "/RedeemHistory",
                  show: featureToggle?.redeem,
                },
                {
                  key: "sip",
                  icon: <SipIcon sx={{ fontSize: 35, color: "#ff6ec7" }} />,
                  label: "SIP Plan",
                  path: "/CustomerSipScreen",
                  show: featureToggle?.sip,
                },
                {
                  key: "sell",
                  icon: (
                    <CurrencyRupeeIcon
                      sx={{ fontSize: 35, color: "#00d4ff" }}
                    />
                  ),
                  label: "Sell",
                  path: "/Sell",
                  show: featureToggle?.sell,
                },
                {
                  key: "sip_cal",
                  icon: (
                    <CalculateIcon sx={{ fontSize: 35, color: "#ff9a56" }} />
                  ),
                  label: "Sip Calculator",
                  path: "/SIPCalculator",
                  show: featureToggle?.sip,
                },
                {
                  key: "deposit_plan",
                  icon: (
                    <AccountBalanceWalletIcon
                      sx={{ fontSize: 35, color: "#6c63ff" }}
                    />
                  ),
                  label: "Deposit Plan",
                  path: "/allDepositPlan",
                  show: featureToggle?.deposit_plan,
                },
              ]
                .filter((item) => item.show)
                .map((item, index) => (
                  <Card
                    key={index}
                    onClick={() => {
                      if (item.path) navigate(item.path);
                    }}
                    sx={{
                      width: { xs: "calc(50% - 24px)", sm: 120 },
                      maxWidth: 160,
                      height: { xs: 108, sm: 120 },
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border: `1px solid ${themeColors.border}`,
                      borderRadius: "20px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                      cursor: "pointer",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                      },
                      background: themeColors.smallContainer,
                      textAlign: "center",
                      p: 1,
                      color: themeColors.text,
                    }}
                  >
                    {item.icon}
                    <Typography variant="body2" sx={{ mt: 1, fontWeight: 500 }}>
                      {item.label}
                    </Typography>
                  </Card>
                ))}
            </Box>
          </Box>
        </Box>

        <Box sx={{ mt: 5, px: 3, pb: 5 }}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="stretch"
          >
            {featureToggle.sip && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Card
                  sx={{
                    background: themeColors.scaffoldGradientColors,
                    borderRadius: "25px",
                    border: `1px solid ${themeColors.border}`,
                    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                    p: { xs: 2, sm: 4 },
                    height: "auto",
                    width: "100%",
                    maxWidth: "100%",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      sx={{ color: themeColors.primary }}
                    >
                      Grow your income by
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: "bold",
                        mb: 1,
                        color: themeColors.primary,
                      }}
                    >
                      Savings Plan
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ mb: 2, color: themeColors.primary }}
                    >
                      Setup Savings Autopay
                    </Typography>

                    <Grid container spacing={2} justifyContent="center" px={2}>
                      <Grid size={{ xs: 12, sm: 6, md: 5 }}>
                        <Card
                          onClick={() => navigate("/AllSipScreen")}
                          sx={{
                            background: themeColors.mediumContainer,
                            borderRadius: "20px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                            color: themeColors.text,
                            transition: "transform 0.3s",
                            "&:hover": { transform: "translateY(-5px)" },
                            cursor: "pointer",
                          }}
                        >
                          <CardContent
                            sx={{
                              textAlign: "center",
                              py: 5,
                              marginLeft: 2,
                              marginRight: 2,
                            }}
                          >
                            <TodayIcon
                              fontSize="large"
                              sx={{ mb: 1, color: themeColors.text }}
                            />
                            <Typography variant="h6">Daily SIP</Typography>
                            <Typography variant="body2">
                              Save every Day
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6, md: 5 }}>
                        <Card
                          onClick={() => navigate("/AllSipScreen")}
                          sx={{
                            background: themeColors.mediumContainer,
                            borderRadius: "20px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                            color: themeColors.text,
                            transition: "transform 0.3s",
                            "&:hover": { transform: "translateY(-5px)" },
                            cursor: "pointer",
                          }}
                        >
                          <CardContent
                            sx={{
                              textAlign: "center",
                              py: 5,
                              marginLeft: 2,
                              marginRight: 2,
                            }}
                          >
                            <DateRangeIcon
                              fontSize="large"
                              sx={{ mb: 1, color: themeColors.text }}
                            />
                            <Typography variant="h6">Weekly SIP</Typography>
                            <Typography variant="body2">
                              Save every week
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      <Grid size={{ xs: 12, sm: 6, md: 5 }}>
                        <Card
                          onClick={() => navigate("/AllSipScreen")}
                          sx={{
                            background: themeColors.mediumContainer,
                            borderRadius: "20px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                            color: themeColors.text,
                            transition: "transform 0.3s",
                            "&:hover": { transform: "translateY(-5px)" },
                            cursor: "pointer",
                          }}
                        >
                          <CardContent
                            sx={{
                              textAlign: "center",
                              py: 5,
                              marginLeft: 2,
                              marginRight: 2,
                            }}
                          >
                            <CalendarMonthIcon
                              fontSize="large"
                              sx={{ mb: 1, color: themeColors.text }}
                            />
                            <Typography variant="h6">Monthly SIP</Typography>
                            <Typography variant="body2">
                              {" "}
                              Save every Month
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
              </Grid>
            )}

            {featureToggle.gift && (
              <Grid size={{ xs: 12, md: 6 }}>
                <Card
                  sx={{
                    position: "relative",
                    background: "#fff",
                    border: `1px solid ${themeColors.border}`,
                    borderRadius: "25px",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                    color: themeColors.text,
                    textAlign: "center",
                    minHeight: { xs: 260, md: 300 },
                    height: { xs: "auto", md: "100%" },
                    width: "100%",
                    maxWidth: 520,
                    mx: "auto",
                    overflow: "hidden",
                    p: 0,
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/Gifts")}
                >
                  <Box
                    component="img"
                    src={GiftImage}
                    alt="Gift Gold"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      opacity: 0.9,
                      filter: "brightness(0.85)",
                    }}
                  />

                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: themeColors.text,
                      textShadow: "0 3px 8px rgba(0,0,0,0.5)",
                      px: 3,
                      py: 4,
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                      Gift Your Friend
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        color: themeColors.text,
                        mb: 3,
                        fontSize: "0.95rem",
                      }}
                    >
                      Share the joy of smart saving with your friends!
                    </Typography>

                    <Button
                      variant="contained"
                      sx={{
                        background: "linear-gradient(90deg, #6c63ff, #ff6ec7)",
                        borderRadius: "25px",
                        px: 4,
                        py: 1,
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                        "&:hover": {
                          background:
                            "linear-gradient(90deg, #5b52e6, #e554c9)",
                        },
                      }}
                    >
                      Gift your friend free gold
                    </Button>

                    <Typography
                      variant="h6"
                      sx={{
                        mt: 3,
                        fontWeight: "bold",
                        color: themeColors.text,
                      }}
                    >
                      {symbol}100 worth Free Gold!
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            )}
          </Grid>
        </Box>
        <CustomerInteraction themeColors={themeColors} />
        {bottomCarousel && (
          <CarouselSlider
            slides={bottomCarousel.slides}
            height={bottomCarousel.height}
            showNavigator={bottomCarousel.showNavigator}
            duration={bottomCarousel.duration}
          />
        )}
      </Box>
      {activeOffers?.bannerLink && (
        <Dialog
          open={showOfferDialog}
          onClose={() => setShowOfferDialog(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              position: "relative",
              borderRadius: 3,
              overflow: "hidden",
            },
          }}
        >
          <IconButton
            onClick={() => setShowOfferDialog(false)}
            sx={{
              position: "absolute",
              top: 8,
              left: 8,
              zIndex: 10,
              background: "rgba(255,255,255,0.7)",
              "&:hover": { background: "rgba(255,255,255,0.9)" },
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent sx={{ p: 0 }}>
            <Box
              component="img"
              src={activeOffers?.bannerLink}
              alt="Active Offer"
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </DialogContent>
        </Dialog>
      )}
      <DashboardNotificationDialog
        open={openNotificationDialog}
        onClose={() => setOpenNotificationDialog(false)}
        notification={latestNotification}
      />
      <Dialog
        open={showEarnDialog}
        onClose={() => setShowEarnDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent
          sx={{
            background: themeColors.scaffoldGradientColors,
            color: themeColors.text,
            minHeight: 360,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <IconButton
              onClick={() => setShowEarnDialog(false)}
              sx={{ color: themeColors.text }}
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ fontWeight: 700, fontSize: "1.15rem" }}>
              How to Earn Diamond Points
            </Typography>
          </Box>

          {diamondEarnSections(
            activeConfigurations,
            isVipCustomer ? "vip" : "standard",
          ).length === 0 ? (
            <Box
              sx={{
                minHeight: 280,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                px: 2,
              }}
            >
              <Typography sx={{ mb: 2, color: themeColors.text }}>
                Great things take time. We are building something special for
                you! A golden feature is on it's way ✨
              </Typography>
              <Typography sx={{ letterSpacing: 1, fontWeight: 600 }}>
                COMING SOON...
              </Typography>
            </Box>
          ) : (
            <>
              <Typography sx={{ fontWeight: 700, mb: 2 }}>
                Ways to Earn Diamond Points
              </Typography>
              {diamondEarnSections(
                activeConfigurations,
                isVipCustomer ? "vip" : "standard",
              ).map((section) => (
                <Box
                  key={section.title}
                  sx={{
                    border: `1px solid ${themeColors.scaffold}`,
                    borderRadius: 3,
                    p: 2,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      mb: 2,
                    }}
                  >
                    <DiamondIcon />
                    <Typography sx={{ fontWeight: 700 }}>
                      {section.title}
                    </Typography>
                  </Box>
                  {section.lines.map((line) => (
                    <Box
                      key={line}
                      sx={{
                        display: "flex",
                        gap: 1,
                        mb: 1.5,
                        p: 1.5,
                        borderRadius: 2,
                        background: themeColors.mediumContainer,
                      }}
                    >
                      <InfoOutlinedIcon fontSize="small" />
                      <Typography variant="body2">{line}</Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Dashboard;
